<template>
    <v-card style="background-color: #efeded; height: 100%">
        <v-card-text>
            <v-row>
                <v-col><v-icon @click="dialog = true" color="primary">mdi-brush-outline</v-icon></v-col>
                <v-col class="text-end">
                    <!-- Button group to toggle between Horizontal and Vertical views -->
                    <v-btn-toggle v-model="selectedChart" class="mb-4" mandatory shaped>
                        <v-btn value="chart1">{{$t('ChartOne')}}</v-btn>
                        <v-btn value="chart2">{{$t('ChartTwo')}}</v-btn>
                        <v-btn value="chart3">{{$t('ChartThree')}}</v-btn>
                        <v-btn value="chart4">{{$t('ChartFour')}}</v-btn>
                    </v-btn-toggle>
                </v-col>
                
            </v-row>
            <v-dialog v-model="dialog" persistent max-width="500px">
                <v-card>
                    <div class="card-title">
                        {{ $t('ChangeColor')}}
                    </div>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="4" v-for="(item, index) in value"
                                   :key="index">
                                <v-color-picker v-model="item.color"
                                                mode="hexa"></v-color-picker>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false" text>{{$t('Close')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- Horizontal layout -->
            <v-row v-if="selectedChart === 'chart1'" style="margin-top: 10px;">
                <v-col>
                    <v-row class="d-flex align-center justify-space-between " style="background-color: #efeded; border-radius: 8px;">
                        <v-col cols="auto" style="position:relative">

                            <div :style="'position:absolute;right:10px;top:50px;width:100px;height:201px;background-image:url(/satisfactionbackground.png);background-size:contain;background-repeat:no-repeat;background-position:top center'">
                                <table style="width:100%">
                                    <tr>
                                        <td style="text-align:center;font-size:12px;color:white;padding-top:20px"><img src="/satisfactionstars.png" style="margin:auto" /><br />{{$t('OverAllSAtisfaction')}}</td>
                                    </tr>
                                    <tr><td style="font-weight: 700; padding-top: 40px; text-align: center; font-size: 25px; color: #5EBFCE">{{publicsatisfactoryPerc}}%</td></tr>
                                </table>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <!-- Satisfaction Table -->
                        <v-col cols="2">
                        </v-col>
                        <!-- Satisfaction Levels with Vertical Bars -->
                        <v-col cols="10" class="d-flex justify-center">
                            <v-row>
                                <v-col v-for="(item, index) in value"
                                       :key="index"
                                       class="text-center d-flex flex-column align-center" cols="4" md="2">
                                    <div class="mt-2" style="font-size: 21px; color: #000;">{{ item.percentage }}%</div>
                                    <div class="bar-container chart4 d-flex flex-column justify-end">
                                        <div class="bar"
                                             :style="{
                      height: `${item.percentage}%`,
                      backgroundColor: item.color
                    }">
                                            <!--<table style="height: 100%; margin-top: -10px; width: 100%; font-weight: bold; font-size: 21px;"><tr><td valign="middle"><span>{{ item.percentage }}%</span></td></tr></table>-->
                                        </div>
                                    </div>
                                    <div class="mt-2" style="font-size: 21px; color: #000;">{{ item.level }}</div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <!-- Vertical layout -->
            <v-row v-if="selectedChart === 'chart2'" style="margin-top: -50px;">
                <v-col>

                    <v-row class="d-flex align-center justify-space-between " style="background-color: #efeded; border-radius: 8px;">
                        <v-col cols="auto" style="position:relative">

                            <div :style="'width:200px;height:100px;background-image:url(/satisfactiontitle2.png);background-size:contain;background-repeat:no-repeat;background-position:top center'">
                                <table style="width:94%">
                                    <tr>
                                        <td style="text-align:center;font-size:12px;color:white;padding-top:30px;width:65%">{{$t('OverAllSAtisfaction')}}</td>
                                        <td style="font-weight: 700; text-align: center; font-size: 20px; color: #5EBFCE; padding-top: 30px">{{publicsatisfactoryPerc}}%</td>
                                    </tr>
                                </table>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>

                        <!-- Satisfaction Levels with Vertical Bars -->
                        <v-col cols="12" class="d-flex justify-center">
                            <v-row>
                                <v-col v-for="(item, index) in value"
                                       :key="index"
                                       class="text-center d-flex flex-column align-center">
                                    <div style="background-color:white;border-radius:50px;width:100px;padding:0 0px 10px 0px;text-align:center;height:250px">
                                        <img :src="`face${item.id}.png`" style="width:100%" /><br /><br /><br />
                                        <span :style="`color:${item.color};font-weight:700;font-size:25px`">{{item.percentage}}%</span><br /><br />
                                        <span style="font-size: 18px; color: #000;">{{ item.level }} </span>
                                    </div>

                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                </v-col>
            </v-row>
            <v-row v-if="selectedChart === 'chart3'" style="margin-top: -10px; margin-right: 100px;">
                <v-col>

                    <v-row class="d-flex align-center justify-space-between " style="background-color: #efeded; border-radius: 8px;">
                        <v-col cols="auto" style="position:relative">

                            <div :style="'color: #000;position:absolute;right:10px;top:50px;width:100px;height:201px;background-image:url(/satisfactionbackground.png);background-size:contain;background-repeat:no-repeat;background-position:top center'">
                                <table style="width:100%">
                                    <tr>
                                        <td style="text-align:center;font-size:12px;color:white;padding-top:20px"><img src="/satisfactionstars.png" style="margin:auto" /><br />{{$t('OverAllSAtisfaction')}}</td>
                                    </tr>
                                    <tr><td style="font-weight: 700; padding-top: 40px; text-align: center; font-size: 25px; color: #5EBFCE">{{publicsatisfactoryPerc}}%</td></tr>
                                </table>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <!-- Satisfaction Table -->
                        <v-col cols="2">

                        </v-col>

                        <!-- Satisfaction Levels with Vertical Bars -->
                        <v-col cols="8" class="d-flex justify-center">
                            <v-row>
                                <v-col v-for="(item, index) in value"
                                       :key="index"
                                       class="text-center d-flex flex-column align-center">

                                    <div class="bar-container chart3 d-flex flex-column justify-end">
                                        <div style="color: #000;position:absolute;top:2px; font-size: 21px;">{{ item.percentage }}%</div>
                                        <div class="rotated-text" style="font-size: 21px;">{{ item.level }}</div>
                                        <div class="bar"
                                             :style="{
                                                      height: `${item.percentage}%`,
                                                      backgroundColor: item.color
                                                    }"></div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                </v-col>

            </v-row>
            <v-row v-if="selectedChart === 'chart4'" style="">
                <v-col>
                    <v-row class="d-flex align-center justify-space-between " style="background-color: #efeded; border-radius: 8px;">
                        <v-col cols="auto" style="position:relative">

                            <div :style="'position:absolute;right:10px;top:85px;width:100px;height:201px;background-image:url(/satisfactionbackground.png);background-size:contain;background-repeat:no-repeat;background-position:top center'">
                                <table style="width:100%">
                                    <tr>
                                        <td style="text-align:center;font-size:12px;color:white;padding-top:20px"><img src="/satisfactionstars.png" style="margin:auto" /><br />{{$t('OverAllSAtisfaction')}}</td>
                                    </tr>
                                    <tr><td style="font-weight: 700; padding-top: 40px; text-align: center; font-size: 25px; color: #5EBFCE">{{publicsatisfactoryPerc}}%</td></tr>
                                </table>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <!-- Satisfaction Table -->
                        <v-col cols="2">
                        </v-col>
                        <!-- Satisfaction Levels with Vertical Bars -->
                        <v-col cols="10" class="d-flex justify-center">
                            <v-row>
                                <v-col v-for="(item, index) in value"
                                       :key="index"
                                       class="text-center d-flex flex-column align-center" cols="4" md="2">
                                    <img :src="`face${item.id}.png`" style="width:50px" /><br />
                                    <div class="mt-2" style="font-size: 21px; color: #000;">{{ item.percentage }}%</div>
                                    <div class="bar-container chart4 d-flex flex-column justify-end">
                                        <div class="bar"
                                             :style="{
                                      height: `${item.percentage}%`,
                                      backgroundColor: item.color
                                    }">
                                            <!--<table style="height: 100%; margin-top: -10px; width: 100%; font-weight: bold; font-size: 21px;"><tr><td valign="middle"><span>{{ item.percentage }}%</span></td></tr></table>-->
                                        </div>
                                    </div>
                                    <div class="mt-2" style="font-size: 21px; color: #000;">{{ item.level }}</div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>

</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },

        },
        data() {
            return {
                selectedChart: 'chart1', // Default to horizontal view
                dialog:false
            }
        },
        computed: {
            publicsatisfactoryPerc() {

                var five = this.value.filter(x => x.id == 5)
                var four = this.value.filter(x => x.id == 4)

                var satisfactory = 0
                if (five.length > 0)
                    satisfactory += five[0].percentage
                if (four.length > 0)
                    satisfactory += four[0].percentage
                return satisfactory
            },
            publicsatisfactoryTotal() {
                var satisfactory = 0
                for (var i = 0; i < this.value.length; i++) {
                    satisfactory += this.value[i].count
                }
                return satisfactory
            }

        }
    }
</script>

<style scoped>
    .text-center {
        text-align: center;
    }

    .text-right {
        text-align: right;
    }

    .text-caption {
        font-weight: bold;
        background-color: #eef0f2;
        padding: 5px;
        border-radius: 5px;
    }

    .bar-container {
        height: 150px;
        width: 30px;
        background-color: #eef0f2;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        border-radius: 4px;
    }

    .bar {
        width: 100%;
        border-radius: 4px;
    }

    .chart3 {
        width: 50px;
        height: 300px;
        position: relative
    }

    .chart4 {
        width: 100%;
        height: 140px;
        position: relative;
        border-radius: 20px;
        border: 5px solid white;
    }

        .chart4 .bar {
            border-radius: 10px;
        }

    .d-flex {
        display: flex;
    }

    .align-center {
        align-items: center;
    }

    .flex-column {
        flex-direction: column;
    }

    .rotated-text {
        display: inline-block; /* Ensures the rotation works properly */
        transform: rotate(270deg); /* Rotates text by 45 degrees */
        transform-origin: center; /* Sets the point around which the text is rotated */
        position: absolute;
        bottom: 100px;
        width: 280px;
        color: rgb(0, 0, 0)
    }
</style>
